const state = {
  dossier: null,
};

const getters = {
  getDossier: storeState => storeState.dossier,
};

const mutations = {
  SET_DOSSIER(storeState, dossier) {
    Object.assign(storeState, {
      dossier,
    });
  },
};

const actions = {
  setDossier({ commit }, dossier) {
    commit('SET_DOSSIER', dossier);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
